import ScrollReveal from 'scrollreveal';

export default function InitPageAnimate() {
  ScrollReveal().reveal('.js-scrollreveal-title', {
    distance: '15px',
    duration: 500,
    interval: 100,
    viewFactor: 0.5,
  });

  ScrollReveal().reveal('.js-scrollreveal', {
    distance: '50px',
    duration: 1000,
    interval: 200,
    viewFactor: 0.25,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/pageanimate.js